<template>
  <button
    :type="type"
    class="btn btn-primary"
    :class="{ 'btn-lg': !inline, 'w-100': !inline, 'rounded-pill' : pill, 'float-right': floatRight }"
    :disabled="disabled||loading"
    v-on="$listeners"
  >
    <slot/>
  </button>
</template>

<script>
  export default {
    name: 'SubmitButton',
    props: {
      loading: Boolean,
      disabled: Boolean,
      inline: Boolean,
      pill: Boolean,
      fillBackground: Boolean,
      floatRight: Boolean,
      type: {
        type: String,
        default: 'submit',
      },
    },
  };
</script>
